export default __webpack_public_path__ + "static/media/KSH.3284961e.svg";